<template>


  <LocalizedLink 
    :to="target" 
    class="position-absolute" 
    :class="arrowClass" 
    ref="arrow"
    >
		<div class="arrow-triangle"></div>
	</LocalizedLink>
</template>

<script>
import LocalizedLink from '@/components/LocalizedLink'
import {inject} from "vue";

export default {
  name: "arrow",
	components: {
		LocalizedLink
	},
  setup() {
    const store = inject("store");
    return {
      actions: store.actions
    };
  },
  props: {
    arrowClass: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.arrow-left,
.arrow-right {
  width: 0;
  height: 0;
	top: 50%;
	transform: translate(0, -50%);	
	border-top: 25px solid transparent;
	border-bottom: 25px solid transparent;
	.arrow-triangle {
		border-top: 20px solid transparent;
		border-bottom: 20px solid transparent;
    position: relative;
    top: -20px;
    width: 0;
    height: 0;		

	}
}
.arrow-right {
  right: 10px;
	border-left: 25px solid #fff;	
	.arrow-triangle {
		border-left: 20px solid $color-red;
    right: 2px;
		left: -23px;
	}
}

.arrow-left {
  left: 10px;
	border-right: 25px solid #fff;	
	.arrow-triangle {
		border-right: 20px solid $color-red;
    left: 3px;
	}
}
</style>
